import { render, staticRenderFns } from "./MeasurementInfo.vue?vue&type=template&id=71b13233&scoped=true"
import script from "./MeasurementInfo.vue?vue&type=script&lang=js"
export * from "./MeasurementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b13233",
  null
  
)

export default component.exports